const React = require('react');


/* eslint-disable */
module.exports = (props) => {
  return (
    <div>
      <div
        className="f29 fw3 lh44 lts0em"
      >Allow your customers to make<br/>
        instant deposits in cryptocurrency</div>
      <div className="mt20 f23 fw3 lh34 lts0em">
        with Credit Card, Sofort, iDeal and other<br/>
        payment methods
      </div>
      <div className="mt40">
        <div className="w440 wmax mhA rlv">
          <div className="abs s layoutRow fhaC fvaC">
            <svg
              viewBox="0 0 253 269"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="dB fill231F20>path w253 mhA"
            >
              <path
                opacity="0.2"
                d="M231.14 46.3712C217.91 31.1412 204 18.0812 198 15.5212C184.54 9.52118 168.06 8.57118 156.11 11.8812L42.11 43.4912C22.75 48.8512 6.16 67.5112 0 88.0012H6.43C12.71 68.8012 28.32 51.5512 46.43 46.4912L156.13 15.9112C169.116 12.5344 182.863 13.6553 195.13 19.0912C200.95 21.5712 214.29 34.1712 227.01 48.8712C237.63 61.1412 251.52 78.6312 246.38 100.871C242.64 121.511 224.23 196.461 218.3 222.281C212.37 248.101 173.48 268.081 151.16 261.891C136.23 258.891 84.16 245.971 64.1 241.121C44.04 236.271 29 216.001 27 207.001C26.64 205.361 25.79 201.801 24.62 197.001H18.93C20.44 203.151 21.54 207.721 21.93 209.671C24 218.911 39.61 240.001 60.51 245.001C81.41 250.001 136.87 263.731 152.39 266.871C175.6 273.291 216.01 252.621 222.16 225.871C228.31 199.121 247.42 121.541 251.3 100.181C256.63 77.1912 242.18 59.0812 231.14 46.3712Z"
              />
              <path
                opacity="0.4"
                d="M237 69.4612C237 46.4612 219.14 32.4612 205.74 22.8812C189.74 11.3812 173.49 2.09116 167.13 1.01116C152.91 -1.63884 136.91 1.12116 126.19 6.94116L24 62.4812C14.1 67.8612 5.99999 77.1512 0.679993 88.0012H13.1C18 79.3412 24.74 72.0012 32.88 67.5612L126.58 16.5612C137.724 10.7499 150.491 8.83154 162.85 11.1112C168.68 12.1112 183.52 20.6412 198.24 31.2012C210.52 40.0012 226.89 52.8112 226.89 74.0012C227.83 93.4412 226.89 165.051 226.89 189.641C226.89 214.231 195.64 240.571 173.95 239.741C159.69 240.201 109.45 239.661 90.08 239.571C70.71 239.481 52.72 224.301 49 216.671C47.81 214.181 43.94 206.591 39 197.011H27.48C34.33 210.341 40.05 221.531 41.61 224.771C45.61 233.081 65.23 249.571 86.37 249.661C107.51 249.751 163.69 250.351 179.25 249.851C202.91 250.751 237.03 222.071 237 195.321C236.97 168.571 238 90.6212 237 69.4612Z"
              />
            </svg>
          </div>
          <div className="rlv h268 layoutRow fhaS fvaC f30 fw3 lh44 lts0em tr c5B47FF">
            <div>
              less code<br/>
              or code-free setup
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
